applyDocuments.classy.controller({
    name: 'ApplyDocumentsController',
    inject: ['$scope', 'BinFactory', 'authServiceFactory','ModelService', 'StandardCudService'],
    init: function() 
    {
        this.$.authServiceFactory = this.authServiceFactory;
        this.$.ModelService = this.ModelService; 
        this.$.applications = this.ModelService.school.applications.get();
        this.$.items = this.BinFactory.get();
        this.$.versionNo = versionNo;
        this.$.person = [];
    }
})



